import PropTypes from 'prop-types';
export var opacityLayerPropTypes = {
  /** Show left and right scroll borders if true. */
  opacityLayer: PropTypes.bool,
  /** CSS class name of left scroll border. */
  opacityLeftClass: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /** CSS class name of right scroll border. */
  opacityRightClass: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
};
export var opacityLayerDefaultProps = {
  opacityLayer: false,
  opacityLeftClass: null,
  opacityRightClass: null
};
export var switchPropTypes = {
  /** Do not display `Switch` control if set to true. */
  noSwitch: PropTypes.bool,
  /** CSS class name for every dot in `Switch` */
  dotClass: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
};
export var switchDefaultProps = {
  noSwitch: false,
  dotClass: null
};
export var arrowsPropTypes = {
  /** Do not display `Arrow` controls if set to true. */
  noArrows: PropTypes.bool,
  /** CSS class name for every `Arrow` */
  arrowClass: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
};
export var arrowsDefaultProps = {
  noArrows: false,
  arrowClass: null
};
export var basicPropTypes = {
  /**
   * Time (in milliseconds) before adjustment start after scroll end. Every value less then 50 will
   * become 50ms
   */
  adjustmentTimeout: PropTypes.number,
  /**
   * Ratio of frame position to detect currently scrolled over frame.
   */
  adjustmentDisplaceRatio: PropTypes.number,
  /**
   * Do not animate frame switching
   * @deprecated Will be removed in v2.0.0
   */
  noTransition: PropTypes.bool,
  /** Set to infinite scroll if true. */
  cycle: PropTypes.bool,
  /** Allow to use mouse or touch to control scroll if true. */
  draggable: PropTypes.bool,
  /** Amount of frames to show on one "screen". */
  framesPerSlide: PropTypes.number,
  /** Amount of frames to skip while switching. */
  step: PropTypes.number,
  /** Distance betwwen 2 `Frames`. */
  gutter: PropTypes.number,
  /**
   * Amount of time between auto switches.
   * If set to 0 auto switch will be disabled.
   */
  autoSwitchTime: PropTypes.number,
  /** Width of one frame to show. */
  frameWidth: PropTypes.number,
  /**
   * Amount of time to animate frames swtiching.
   * Disable animation (instant switch) if equals 0.
   */
  transitionDuration: PropTypes.number,
  /**
   * Executes every time right before frame switch.
   * @type {(frameIndex: number) => void}
   * @param {Number} frameIndex - index of frame to be selected
   */
  onSwitchStart: PropTypes.func,
  /** CSS class name of whole component */
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
};
export var basicDefaultProps = {
  adjustmentTimeout: 50,
  adjustmentDisplaceRatio: 0.5,
  noTransition: false,
  cycle: false,
  framesPerSlide: 1,
  step: 1,
  frameWidth: 0,
  gutter: 0,
  autoSwitchTime: 0,
  draggable: false,
  transitionDuration: 500,
  onSwitchStart: function onSwitchStart() {},
  className: null
};